export const LegendWis2GtsSynop = (report, baseline, period_type) => {
  let ret = {
    title: "",
    body: []
  };
  if (report === "gts-to-wis2") {
    ret = {
      title: "WIS2 VS GTS",
      body: [
        {
          label: "WIS2 Only",
          color: "rgb(0, 153, 0)",
          filter: "cl-wis2-only"
        },
        {
          label: "GTS Only",
          color: "#8B0000",
          filter: "cl-gts-only"
        },

        {
          label: "WIS2 & GTS",
          color: "#0000FF",
          filter: "cl-wis2-gts"
        }
      ]
    };
  } else if (report === "tac-to-bufr") {
    ret = {
      title: "BUFR VS TAC",
      body: [
        {
          label: "BUFR Only",
          color: "#00AA00",
          filter: "cl-bufr-only"
        },
        {
          label: "TAC Only",
          color: "#8B0000",
          filter: "cl-tac-only"
        },
        {
          label: "Both BUFR & TAC",
          color: "#0000FF",
          filter: "cl-both"
        }
      ]
    };
  } else if (report === "bufr_oscar_coords") {
    ret = {
      title: "DISTANCE DIFFERENCE (m)",
      body: [
        {
          label: "1 - 10 m",
          color: "#FFCDD2", // Very light red
          filter: "cl-dist-low"
        },
        {
          label: "10 - 1000 m",
          color: "#E57373", // Medium red
          filter: "cl-dist-medium"
        },
        {
          label: "> 1000 m",
          color: "#C62828", // Dark red
          filter: "cl-dist-high"
        }
      ]
    };
  }
  return ret;
};
